/**
 * What: Renders placeholder text lines for content still loading, matching the shape of
 * classic Polaris `SkeletonBodyText`.
 * Transport / data-flow: Pure presentation; no state, no props beyond line count.
 *
 * No `s-skeleton`/`s-skeleton-body-text` in @shopify/polaris-types yet — hand-built from
 * `s-stack`/`s-box`, same "hand-build the missing primitive" technique as the bar in
 * CreditUsageBar.tsx and the empty state in HouseEmptyState.tsx. The last line renders
 * shorter than the rest, matching the real component's look of trailing off mid-sentence.
 */

import './SkeletonBodyTextShim.css'

interface SkeletonBodyTextShimProps {
  /** Number of placeholder lines to render. Defaults to 3, matching classic Polaris. */
  lines?: number
}

export function SkeletonBodyText({ lines = 3 }: SkeletonBodyTextShimProps) {
  return (
    <div className="tf-skeleton-placeholder">
      <s-stack gap="small-200" aria-hidden="true">
        {Array.from({ length: lines }, (_, index) => (
          <s-box
            key={index}
            background="subdued"
            borderRadius="small"
            blockSize="12px"
            inlineSize={index === lines - 1 ? '60%' : '100%'}
          />
        ))}
      </s-stack>
    </div>
  )
}
